import { saveAs } from 'file-saver';

import { PostingFileDetailsExportService } from './posting-file-details-export.service';

/**
 * This is provided as a factory because the `file-saver` dependency needs to be injected.
 */
export function postingFileDetailsExportServiceFactory(): PostingFileDetailsExportService {
  return new PostingFileDetailsExportService(saveAs);
}

export const PostingFileDetailsExportServiceProvider = {
  provide: PostingFileDetailsExportService,
  useFactory: postingFileDetailsExportServiceFactory,
  deps: []
};
